import { useInviteCodeStore } from '../store/invite-code';
import { inviteCodeSchema } from '../utils/schema';
import { useLayoutEffect } from 'react';
import { useSearchParams } from 'wouter';

export const useInitApp = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code')?.toUpperCase();
  const setInviteCode = useInviteCodeStore(state => state.setInviteCode);

  useLayoutEffect(() => {
    const inviteCode = inviteCodeSchema.safeParse(code);
    if (inviteCode.success) {
      setInviteCode(inviteCode.data);
    }
  }, [code, setInviteCode]);

  // No baseToken reset on mount: the persisted wallet-lens choice is restored
  // by the store's merge (address -> config lookup); resetting to
  // DEFAULT_BASE_TOKEN here would clobber it on every reload (harmless only
  // on single-token tenants, where this legacy reset came from).
};

export default useInitApp;
